import type { TOrdersByType } from '../interfaces/orders';

import { ProxyClient } from './clients/ProxyClient';

export interface IOrdersParams {
  ProductTypes?: string[];
  Targets?: 'android' | 'ios' | 'web' | 'mobile';
  From?: string;
  To?: string;
  PageIndex?: number;
  PageSize?: number;
}

export const getOrders = async (params: IOrdersParams): Promise<TOrdersByType> => {
  const { data } = await ProxyClient.get<TOrdersByType>(`/orders`, {
    params,
  });

  return data;
};
